export const TAYLORMADE_TEAMS = [
  "688d17c34df76f3138243242",
  "68b0892c4cbd93fb05323b73",
  "68b088f84cbd93fb05323b72",
  "6890dec36d99d3d90659a4a3",
];
export const SUNDAYRED_TEAMS = [
  "68b08aa14cbd93fb05323b77",
  "68b075304cbd93fb05323b6e",
  "68b08a664cbd93fb05323b76",
  "6890df432cf991a06c849d25",
];
